// App.js
import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Courses from './components/Courses';
import Feedback from './components/Feedback';
import Gallery from './components/Gallery';
import Results from './components/Results';
import Resources from './components/Resources'; // IMPORT THIS
import EnquiryForm from './components/EnquiryForm';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
    const [showBrochure, setShowBrochure] = useState(false);

    const handleAdmissionClick = () => {
        console.log('Navbar badge clicked in App.js');
        setShowBrochure(true);
        
        if (window.openAdmissionPopup) {
            window.openAdmissionPopup();
        }
    };

    return (
        <div className="App">
            <Navbar onAdmissionClick={handleAdmissionClick} />
            <Hero 
                showBrochure={showBrochure} 
                setShowBrochure={setShowBrochure}
            />
            <About />
            <Courses />
            <Gallery />
            <Results />
            <Resources /> {/* ADD THIS LINE - Between Results and Feedback */}
            <Feedback />
            <EnquiryForm />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;